export enum MessageStatus {
  Success = 'success',
  Error = 'error',
}

export class Message<T = unknown> {
  constructor(
    public readonly type: string,
    public token = '',
    public readonly data?: T,
    public readonly opid?: string,
  ) {}
}

export class ResponseMessage<T = unknown> extends Message<T> {
  constructor(
    type: string,
    public readonly status: MessageStatus,
    token = '',
    data?: T,
    opid?: string,
  ) {
    super(type, token, data, opid);
  }
}

export interface HasToken {
  setToken(token: string): void;
}

export class MessageRequest<T = any> implements HasToken {
  constructor(public request: Message<T>) {}

  setToken(token: string): void {
    this.request.token = token;
  }
}

export class MessageResponse<T = any> implements HasToken {
  constructor(public response: ResponseMessage<T>) {}

  setToken(token: string): void {
    this.response.token = token;
  }
}
